import store from "@/store";

export default (options, url) => {
  store.dispatch("auth/setBackurl", {
    path: url,
    query: options.route.from.query,
  });
  options.route.next();
};
